const exampleJson = {
    list: [{
        id: 6,
        class: 'style1',
        // image: require('../../assets/images/example/3.png'),
        image: './images/example/6.png',
        mobimage: './images/example/mob/6.png',
        date: '2021/8',
        title: '职场数字化互动体验提升',
        link: '/detail/6'
    }, {
        id: 7,
        class: 'style2',
        // image: require('../../assets/images/example/3.png'),
        image: './images/example/7.png',
        mobimage: './images/example/mob/7.png',
        date: '2021/12',
        title: '金融科技数字化体验创新',
        link: '/detail/7'
    }, {
        id: 8,
        class: 'style2',
        // image: require('../../assets/images/example/3.png'),
        image: './images/example/8.png',
        mobimage: './images/example/mob/8.png',
        date: '2021/11',
        title: '运营指挥系统数字化体验提升',
        link: '/detail/8'
    }, {
        id: 9,
        class: 'style1',
        // image: require('../../assets/images/example/3.png'),
        image: './images/example/9.png',
        mobimage: './images/example/mob/9.png',
        date: '2021/10',
        title: '数字化演播厅创新设计',
        link: '/detail/9'
    },{
        id: 10,
        class: 'style1',
        // image: require('../../assets/images/example/1.png'),
        image: './images/example/10.png',
        mobimage: './images/example/mob/10.png',
        date: '2020/8',
        title: '智慧政务服务大厅解决方案',
        link: '/detail/10'
    },{
        id: 1,
        class: 'style1',
        // image: require('../../assets/images/example/1.png'),
        image: './images/example/1.png',
        mobimage: './images/example/mob/1.png',
        date: '2019/3',
        title: '三江源国家大数据基地体验之旅',
        link: '/detail/1'
    }, {
        id: 2,
        class: 'style1',
        // image: require('../../assets/images/example/2.png'),
        image: './images/example/2.png',
        mobimage: './images/example/mob/2.png',
        date: '2019/8',
        title: '中网直销票务平台体验优化',
        link: '/detail/2'
    }, {
        id: 4,
        class: 'style2',
        // image: require('../../assets/images/example/4.png'),
        image: './images/example/4.png',
        mobimage: './images/example/mob/4.png',
        date: '2019/10',
        title: '体育赛事/活动会议/文娱演出的数字化运营<br>平台',
        link: '/detail/4'
    }, {
        id: 3,
        class: 'style1',
        // image: require('../../assets/images/example/3.png'),
        image: './images/example/3.png',
        mobimage: './images/example/mob/3.png',
        date: '2018/8',
        title: '中网观众会员服务及管理体系',
        link: '/detail/3'
    }, {
        id: 5,
        class: 'style1',
        // image: require('../../assets/images/example/3.png'),
        image: './images/example/5.png',
        mobimage: './images/example/mob/5.png',
        date: '2019/5',
        title: 'AI 人脸识别验检服务',
        link: '/detail/5'
    }]
}

export default exampleJson